import { ReactNode } from 'react';

const gradients = {
  purple: { from: '#4101f4', to: '#c1ecda' },
  green: { from: '#2ECC71', to: '#2ECC7188' },
  red: { from: '#E74C3C', to: '#E74C3C88' },
  blue: { from: '#3498DB', to: '#3498DB88' },
  orange: { from: '#E67E22', to: '#E67E2288' },
  pink: { from: '#E91E63', to: '#E91E6388' },
  teal: { from: '#009688', to: '#00968888' },
  indigo: { from: '#6366F1', to: '#6366F188' },
} as const;

export type GradientColor = keyof typeof gradients;

export const getGradientStartColor = (color: GradientColor): string =>
  gradients[color].from;

type GradientIconProps = {
  children: ReactNode;
} & (
  | { color?: GradientColor; from?: never; to?: never }
  | { color?: never; from: string; to: string }
);

export const GradientIcon = ({ children, ...rest }: GradientIconProps) => {
  const { from, to } =
    'from' in rest && rest.from
      ? { from: rest.from, to: rest.to }
      : gradients[rest.color ?? 'purple'];

  return (
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: 'var(--bui-radius-2)',
        background: `linear-gradient(45deg, ${from}, ${to})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        flexShrink: 0,
      }}
    >
      {children}
    </div>
  );
};
